module.exports = __webpack_public_path__ + "img/Data.8d756d0c.svg";